import axios from "../axios/index.js";

const urlGetColorList = "/api/get-image/";

export default {
    getImageUrl(url) {
        return axios.get(urlGetColorList, { 
            params: url
        });
    },
};
